import { HelpArticle } from "@/components/HelpArticle/HelpArticle";
import { Screenshot } from "@/components/Screenshot/Screenshot";
import { createFileRoute } from "@tanstack/react-router";
import avvises from "./avvises.png";
import manuellBehandling from "./manuell-behandling.png";
import tinglyst from "./tinglyst.png";

const title = "Valideringsfeil fra Kartverket";

export const Route = createFileRoute("/_authenticated-user/hjelp/valideringsfeil-fra-kartverket/")({
  head: () => ({
    meta: [{ title: `${title} | Alice & Bob` }],
  }),
  component: Page,
});

function Page() {
  return (
    <HelpArticle title={title}>
      <p>Alle valideringsfeil som vises i tinglysingsdokumentet kommer direkte fra Kartverket.</p>
      <p>
        Kontrollen av dokumentet skjer i Kartverkets systemer, og vi viser tilbakemeldingene som Kartverket gir.
        Valideringsfeilene betyr at Kartverket har funnet mangler eller feil i dokumentet. Disse meldingene må leses og
        rettes før dokumentet sendes til signering.
      </p>
      <p>
        <strong>Et ferdig signert tinglysingsdokument kan ikke endres.</strong>
      </p>

      <h2>«Sjansen er stor for at forsendelsen vil avvises ved innsending til tinglysing.»</h2>
      <Screenshot
        src={avvises}
        width={752}
        alt="Den røde boksen «Validering fra Kartverket» med meldingen «Sjansen er stor for at forsendelsen vil avvises ved innsending til tinglysing.» og kontrollen «Oppdatering av grunnboken må være gyldig»: «Ikke godkjent: Finnes ingen aktiv andel for person»."
      />
      <p>Dette betyr at forsendelsen vil bli avvist.</p>
      <ul>
        <li>Forsendelsen stoppes og avvises automatisk i Kartverkets systemer.</li>
        <li>Den blir ikke sett på av en saksbehandler.</li>
        <li>Avvisningen skjer uten at forsendelsen registreres hos Kartverket.</li>
      </ul>
      <p>
        <strong>Unntak:</strong> Dokumenter som ellers ville blitt avvist, kan likevel behandles dersom forsendelsen
        også inneholder et annet dokument som ligger først og utløser manuell behandling, for eksempel en
        hjemmelserklæring.
      </p>
      <p>
        Dersom du er usikker på hvordan dokumentet skal fylles ut korrekt, kan du kontakte Kartverket på telefon{" "}
        <a href="tel:+4732118000">32 11 80 00</a>.
      </p>

      <h2>«Sjansen er stor for at forsendelsen vil gå til manuell behandling ved innsending til tinglysing.»</h2>
      <Screenshot
        src={manuellBehandling}
        width={754}
        alt="Den gule boksen «Validering fra Kartverket» med meldingen «Sjansen er stor for at forsendelsen vil gå til manuell behandling ved innsending til tinglysing.» og kontrollen «Kontroll som sender alle saker med visse rettsstiftelsetyper til manuell behandling»: «Uavklart: Sak som inneholder vedlegg krever manuell behandling»."
      />
      <p>
        Dette betyr at forsendelsen ikke behandles automatisk, men må vurderes manuelt av en saksbehandler hos
        Kartverket.
      </p>
      <ul>
        <li>Alle forsendelser med vedlegg går automatisk til manuell behandling.</li>
        <li>Behandlingstiden avhenger av Kartverkets kapasitet.</li>
        <li>Utfallet avgjøres først etter at Kartverket har vurdert forsendelsen.</li>
      </ul>
      <p>
        Dersom forsendelsen blir avvist og ikke blir registrert i grunnboken, får man en detaljert forklaring fra
        Kartverket på feil og mangler. Spørsmål om utfylling eller krav til dokumentasjon må rettes til Kartverket på
        telefon <a href="tel:+4732118000">32 11 80 00</a>.
      </p>

      <h2>Ingen valideringsfeil (hurra 🎉)</h2>
      <p>
        Dersom det ikke foreligger valideringsfeil, betyr det at forsendelsen er korrekt utfylt og vil bli godkjent og
        tinglyst i løpet av få sekunder ved innsending.
      </p>
      <Screenshot
        src={tinglyst}
        width={306}
        alt="Et skjøte med status «Tinglyst» og en forsendelse med meldingen «Meldingen er tinglyst i grunnboken.»"
      />
    </HelpArticle>
  );
}
